import { resolveProductShop, productWithShopPrice } from "../shops/productShop";
// Card.js (Improved Design & Enhanced)
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ShowImage from './ShowImage';
import Price from '../pageInside/productsPrice';
import Loader from '../Layout/loader.gif';
import imgProductLakay from '../Layout/imgs/md3.jpg';
import { MdRemoveCircleOutline, MdAddShoppingCart, MdEdit, MdDeleteForever, MdUnpublished } from 'react-icons/md';
import { FaPlus } from 'react-icons/fa';
import { MdRestore } from 'react-icons/md';
import { addItem, isAuthenticated } from '../auth';
import { AddToDealToDay, softDeleteProduct, restoreProduct, permanentDeleteProduct } from '../auth/apiProduct';
import {
  extract_Na_Ing_galeries,
  extract_Urls_galeriesID,
  compareArrays,
  extract_K_V_filterProduct,
  checkFilterImages,
  selectUrl_By_GaleriesCheck,
  getProductPrimaryImage,
  validateProductData
} from '../auth/elakay-utils';
import './Card.css';
import { elakayAutoText } from "./dataElakay";
import { buildProductEditPath, getProductEditId } from '../../utils/publicIdentifier';
import { getCardGlobalPresentation } from '../../utils/appearanceSettings';
import {
  resolveActiveCardMode,
  getCardVisibility,
  getLandscapeDescriptionStyle,
} from '../../utils/cardDisplaySettings';


const Card = (props) => {
  const { token } = isAuthenticated();
  const [isHovered, setIsHovered] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
  const [descriptionExpanded, setDescriptionExpanded] = useState(false);

  const {
    laguangeElakay,
    infoSource,
    product: sourceProduct,
    showAddToCartButton = true,
    showButtonUser = false,
    classCard0 = 'col p-2',
    classCard1 = '',
    cardStyle: localCardStyle = null,
    style: localStyle = null,
    loadProductsByArrival,
    setProductaddToDeal,
    myFilters = { filters: { "categoriesID.gategoriesLink": [] } },
    getFilterUserProd = { asc: 'asc', unpublished: false, limit: 12, sortBy: 'createdAt', search: '' },
    setShowSideDeal,
    showSideDeal,
    DealProduct,
    CataID,
    showShopV,
    showB,
    owner = null,
    filterSel,
    promoMaker = false,
    btnShopPromo,
    refShopName,
    key = 0,
    edit = false,
    // Card Display Mode (Portrait/Landscape) — Grid pages only. isGridPage
    // gate: Landscape ne s'active jamais si isGridPage n'est pas true, même
    // si displayMode/localStorage/AnimationSettings valent "landscape".
    displayMode,
    cardDataVisibility,
    descriptionMaxCharacters,
    forceLandscape = false,
    isGridPage = false,
    trashMode = false,
  } = props;
  const currentShopId = props.currentShopId || new URLSearchParams(window.location.search).get('shop');
  const productShop = resolveProductShop({ product: sourceProduct, currentShopId });
  const product = productWithShopPrice(sourceProduct, productShop);

  const activeCardMode = resolveActiveCardMode({
    isGridPage,
    displayMode,
    forceLandscape,
    defaultModeFromSettings: infoSource?.allSettings?.cardDisplaySettings?.defaultMode,
  });
  const isLandscape = activeCardMode === 'landscape';
  const cardVisibility = getCardVisibility(
    activeCardMode,
    infoSource?.allSettings?.cardDisplaySettings,
    cardDataVisibility
  );
  const resolvedDescriptionMaxCharacters = descriptionMaxCharacters
    ?? cardVisibility.descriptionMaxCharacters
    ?? 120;

  const { cartItems, trashItems, getButtonTitle } = infoSource;

  const catalID = CataID ?? product?.categoriesID?.[0]?.catID;
  const safeFilterProduct = Array.isArray(product?.filterProduct)
    ? product.filterProduct
    : [];
  const proArrGrToLEss = [...safeFilterProduct].sort((a, b) => b.quantity - a.quantity);

  const urls = extract_Urls_galeriesID(product?.galeriesID);
  const galeries = extract_Na_Ing_galeries(product?.galeries);
  const K_V_filterProduct = extract_K_V_filterProduct(product?.filterProduct);
  const checkFilImages = checkFilterImages(product?.filters);
  const dropshippingPlatform =
    product?.dropshippingData?.platform ||
    product?.dropshippingPlatform ||
    null;
  const dropshippingPlatformName =
    dropshippingPlatform?.name ||
    product?.dropshippingData?.platformName ||
    '';
  const dropshippingPlatformLink =
    product?.dropshippingData?.platformLink ||
    dropshippingPlatform?.platformLink ||
    product?.platformLink ||
    product?.dropshippingData?.platformProductUrl ||
    product?.dropshippingData?.platformUrl ||
    product?.dropshippingData?.productUrl ||
    '';
  const isDropshippingProduct =
    product?.sourceType === 'dropshipping' ||
    Boolean(product?.dropshippingData?.platformName || dropshippingPlatformName);

  const productIncomplete = !validateProductData(product);

  const filColorIncompatible = compareArrays(K_V_filterProduct.values, galeries.names);
  const img_N_E_galeries = compareArrays(urls, galeries.images);
  const img_N_E_filterProduct = compareArrays(urls, checkFilImages.urls);

  const getFallbackImage = () => {
    return getProductPrimaryImage(product, imgProductLakay);
  };

  const addToCart = async ([color, urlImg]) => {
    const filterProduct = color ? proArrGrToLEss.find(p => p?.filter?.color === color) : proArrGrToLEss[0];
    if (!token) return (window.location.href = '/signin');

    setActionLoading(true);
    try {
      const res = await addItem(token, {
        count: 1,
        categoryID: catalID,
        productID: product._id,
        productOrner: product.owner?._id,
        urlImg,
        filterProduct: filterProduct?._id,
      });
      if (!res.error) cartItems(token);
    } finally {
      setActionLoading(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(elakayAutoText("h_delete_product_confirm", "Move this product to the trash? You'll have 14 days to restore it before it's permanently deleted."))) return;
    setActionLoading(true);
    try {
      const res = await softDeleteProduct(token, product._id);
      if (!res?.error) {
        loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
        trashItems?.(token);
      } else alert(res.error);
    } finally {
      setActionLoading(false);
    }
  };

  const handleRestore = async () => {
    setActionLoading(true);
    try {
      const res = await restoreProduct(token, product._id);
      if (!res?.error) {
        loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
        trashItems?.(token);
      } else alert(res.error);
    } finally {
      setActionLoading(false);
    }
  };

  const handlePermanentDelete = async () => {
    if (!window.confirm(elakayAutoText("h_permanent_delete_confirm", "Permanently delete this product? This cannot be undone."))) return;
    setActionLoading(true);
    try {
      const res = await permanentDeleteProduct(token, product._id);
      if (!res?.error) {
        loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
        trashItems?.(token);
      } else alert(res.error);
    } finally {
      setActionLoading(false);
    }
  };

  const handleDealToggle = async () => {
    setActionLoading(true);
    try {
      if (!product.dealTodays) {
        setShowSideDeal(!showSideDeal);
        setProductaddToDeal(product);
      } else {
        await AddToDealToDay(token, product._id, { dealTodays: false, discount: 0 });
        loadProductsByArrival(token, DealProduct, myFilters, getFilterUserProd);
      }
    } finally {
      setActionLoading(false);
    }
  };

  const renderTrashActionButtons = () => (
    <div className="action-buttons-container trash-action-buttons-container">
      <div className="action-buttons-wrapper trash-action-buttons-wrapper">
        {product.canBeRestored !== false ? (
          <button
            className="action-btn restore-btn"
            onClick={handleRestore}
            disabled={actionLoading}
            data-toggle="tooltip"
            data-placement="top"
            title={elakayAutoText("h_restore_product", "Restore")}
          >
            <MdRestore />
            <span>{elakayAutoText("h_restore_product", "Restore")}</span>
          </button>
        ) : (
          <span
            className="action-btn restore-btn restore-btn--disabled"
            title={elakayAutoText("h_restore_blocked_cj", "This product's CJ Dropshipping source no longer exists and must be re-verified before it can be restored.")}
          >
            <MdRestore />
            <span>{elakayAutoText("h_restore_product", "Restore")}</span>
          </span>
        )}
        <button
          className="action-btn delete-btn"
          onClick={handlePermanentDelete}
          disabled={actionLoading}
          data-toggle="tooltip"
          data-placement="top"
          title={elakayAutoText("h_permanent_delete_product", "Delete permanently")}
        >
          <MdDeleteForever />
          <span>{elakayAutoText("h_permanent_delete_product", "Delete permanently")}</span>
        </button>
      </div>
    </div>
  );

  const renderActionButtons = () => {
    if (trashMode) return renderTrashActionButtons();
    return (
    <div className="action-buttons-container">
      {showButtonUser && (
        <div className="action-buttons-wrapper">
          <button
            className="action-btn delete-btn"
            onClick={handleDelete}
            disabled={actionLoading}
            data-toggle="tooltip"
            data-placement="top"
            title={getButtonTitle("deleteProduct")}
          >
            <MdDeleteForever />
          </button>

          <button
            className="action-btn cardproduct-deal-btn"
            onClick={handleDealToggle}
            disabled={actionLoading}
            data-toggle="tooltip"
            data-placement="top"
            title={getButtonTitle(product.dealTodays ? "deleteToDeal" : "addToDeal")}
          >
            {product.dealTodays ? <MdRemoveCircleOutline /> : <FaPlus />}
          </button>

          <Link
            to={buildProductEditPath(product)}
            className="action-btn edit-btn"
            data-toggle="tooltip"
            data-placement="top"
            title={getButtonTitle("editProduct")}
          >
            <MdEdit />
          </Link>

          {!validateProductData(product) && (
            <Link
              to={`/myshop?sel=true&ip=${product._id}`}
              className="action-btn unpublished-btn"
              data-toggle="tooltip"
              data-placement="top"
              title={getButtonTitle("continueSelling")}
            >
              <MdUnpublished />
            </Link>
          )}
        </div>
      )}
    </div>
    );
  };

  const renderAddToCart = ([color, urlImg]) => (
    !edit && showAddToCartButton && (
      <button
        className={`add-to-cart-btn ${promoMaker ? 'promo-style' : 'default-style'}`}
        onClick={() => {
          promoMaker
            ? btnShopPromo(true, null, product._id, `${refShopName}; item: ${product.name.substring(0, 30)}`)
            : addToCart([color, urlImg]);
        }}
        disabled={actionLoading}
        data-toggle="tooltip"
        data-placement="top"
        title={getButtonTitle("addToCart")}
      >
        {actionLoading ? (
          <span className="spinner-small"></span>
        ) : promoMaker ? (
          elakayAutoText("h_e0f4f87da3de72", "Promo")
        ) : (
          <MdAddShoppingCart />
        )}
      </button>
    )
  );

  const renderDropshippingPlatformBadge = () => {
    if (!isDropshippingProduct || !dropshippingPlatformName || !dropshippingPlatformLink) return null;

    const label = dropshippingPlatformName.length > 18
      ? `${dropshippingPlatformName.substring(0, 16)}…`
      : dropshippingPlatformName;
    const title = `Platform: ${dropshippingPlatformName}`;
    const isExternal = /^https?:\/\//i.test(dropshippingPlatformLink);

    if (isExternal) {
      return (
        <a
          className="dropshipping-platform-badge"
          href={dropshippingPlatformLink}
          target="_blank"
          rel="noopener noreferrer"
          title={title}
          onClick={(event) => event.stopPropagation()}
        >
          {label}
        </a>
      );
    }

    return (
      <Link
        className="dropshipping-platform-badge"
        to={dropshippingPlatformLink}
        title={title}
        onClick={(event) => event.stopPropagation()}
      >
        {label}
      </Link>
    );
  };

  const getCardShadowColor = () => {
    if (showButtonUser && productIncomplete) {
      return 'rgba(220, 53, 69, 0.45)'; // Rouge
    } else if (
      showButtonUser &&
      (filColorIncompatible.error || img_N_E_filterProduct.error || img_N_E_galeries.error || checkFilImages.error)
    ) {
      return 'rgba(255, 193, 7, 0.45)'; // Jaune
    } else if (showButtonUser) {
      return 'rgba(25, 135, 84, 0.45)'; // Vert
    } else {
      return 'rgba(0, 115, 153, 0.35)'; // Bleu par défaut
    }
  };

  const interactiveCardStyle = {
    boxShadow: `0 ${isHovered ? '12px 32px' : '4px 12px'} ${getCardShadowColor()}`,
    transform: isHovered ? 'translateY(-4px)' : 'translateY(0)',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  };
  const globalCardPresentation = getCardGlobalPresentation(
    infoSource?.allSettings?.cardGlobalStyle,
    isHovered,
    getCardShadowColor()
  );
  // Cascade explicite : défaut/interactions < AnimationSettings < style local.
  // `cardStyle` et `style` permettent donc à une Card spécialisée de conserver
  // ses choix, même lorsque le style global est activé.
  const resolvedCardStyle = {
    ...interactiveCardStyle,
    ...globalCardPresentation.style,
    ...globalCardPresentation.variables,
    ...(localCardStyle || {}),
    ...(localStyle || {}),
  };

  const renderCard = ([color, urlImg], index) => {
    const rating = product.vote?.length > 0
      ? product.vote.reduce((acc, val) => acc + Math.round(val.voteNum), 0) / product.vote.length
      : 0;

    // Landscape uniquement — best-effort, ne s'affiche que si la donnée
    // existe réellement sur ce produit (aucun risque si absente).
    const safeDescription = product?.description || '';
    const shouldCutDescription = safeDescription.length > resolvedDescriptionMaxCharacters;
    const visibleDescription = descriptionExpanded || !shouldCutDescription
      ? safeDescription
      : `${safeDescription.slice(0, resolvedDescriptionMaxCharacters)}...`;

    const sellerName = product?.owner?.shopName || product?.owner?.userName || '';
    const categoryName = product?.categoriesID?.[0]?.catID?.name || '';
    const stockCount = proArrGrToLEss.reduce((sum, f) => sum + (f?.quantity || 0), 0);
    const topVariant = proArrGrToLEss?.[0];
    const discountPercent = topVariant?.salePrice > 0 && topVariant?.price > topVariant.salePrice
      ? Math.round((1 - topVariant.salePrice / topVariant.price) * 100)
      : 0;

    return (
      <div key={`card-${product._id}-${index}`} className={classCard0}>
        <div
          className={`product-card elakay-grid-card ${trashMode ? 'trash-mode' : ''} ${isLandscape ? 'landscape' : ''} ${globalCardPresentation.className} ${classCard1 || ''}`.trim()}
          style={resolvedCardStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {cardVisibility.showImage && (
            <ShowImage
              currentShopId={currentShopId}
              infoSource={props.infoSource}
              token={token}
              rating={cardVisibility.showRating ? rating : 0}
              nbrUserVote={product.vote?.length}
              item={product}
              urlImg={urlImg}
              isIncompleteProduct={!validateProductData(product)}
              filterProduct={proArrGrToLEss}
              productId={getProductEditId(product)}
              categoryId={catalID}
              showB={showB}
              showShopV={showShopV}
              showButtonUser={showButtonUser}
              filterColor={color}
              owner_id={owner ?? product.owner?._id}
              urlFilter={color && `?color=${color}`}
              url="product"
              edit={edit}
            />
          )}
          {renderDropshippingPlatformBadge()}

          <div className="card-body-modern">
            {cardVisibility.showTitle && (
              <div className="product-name">
                <span>{product.name.substring(0, 19)}...</span>
              </div>
            )}

            {isLandscape && cardVisibility.showCategory && categoryName && (
              <div className="elakay-card-category-landscape">{categoryName}</div>
            )}
            {isLandscape && cardVisibility.showSeller && sellerName && (
              <div className="elakay-card-seller-landscape">{sellerName}</div>
            )}

            {isLandscape && cardVisibility.showDescription && safeDescription && (
              <p
                className="elakay-card-description-landscape"
                style={getLandscapeDescriptionStyle(cardVisibility)}
              >
                {visibleDescription}
                {shouldCutDescription && cardVisibility.showSeeMore && (
                  <button
                    type="button"
                    className="elakay-card-see-more"
                    onClick={() => setDescriptionExpanded((value) => !value)}
                  >
                    {descriptionExpanded ? cardVisibility.seeLessText : cardVisibility.seeMoreText}
                  </button>
                )}
              </p>
            )}

            {cardVisibility.showPrice && (
              <Price products={product} showAddToCart={renderAddToCart} filtername={[color, urlImg]} />
            )}

            {isLandscape && cardVisibility.showStock && stockCount > 0 && (
              <div className="elakay-card-stock-landscape">{stockCount}{elakayAutoText("h_59aa9f0204fbfa", "in stock")}</div>
            )}
            {isLandscape && cardVisibility.showDiscount && discountPercent > 0 && (
              <div className="elakay-card-discount-landscape">-{discountPercent}%</div>
            )}

            {trashMode && (
              <div className="elakay-card-trash-info">
                <div>
                  {product.providerDeleted
                    ? elakayAutoText("h_trash_reason_cj", "Removed by CJ Dropshipping — no longer available from the supplier")
                    : elakayAutoText("h_trash_reason_seller", "Deleted by seller — restorable for 14 days")}
                </div>
                {product.deletionExpiresAt && (
                  <div>
                    {elakayAutoText("h_trash_days_remaining", "{value0} day(s) left before permanent deletion", {
                      value0: Math.max(0, Math.ceil((new Date(product.deletionExpiresAt).getTime() - Date.now()) / 86400000)),
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Les réglages globaux peuvent masquer les boutons catalogue,
                jamais les actions indispensables de la corbeille. */}
            {trashMode ? renderActionButtons() : cardVisibility.showButtons && renderActionButtons()}
          </div>
        </div>
      </div>
    );
  };

  const getDisplayImages = () => {
    const filterColors = filterSel?.['filterProduct.filter.color'];
    const galeries = product?.galeries || [];

    if (!filColorIncompatible.error && galeries?.length > 0 && galeries[0].images?.length > 0) {
      if (filterColors?.length > 0) {
        return galeries.filter(img => filterColors.includes(img.name))?.map(i => [i.name, i.images[0]]);
      }
      return proArrGrToLEss?.length > 0
        ? galeries.filter(img => img.name === proArrGrToLEss[0].filter.color)?.map(i => [i.name, i.images[0]])
        : [['', getFallbackImage()]];
    }

    return [['', getFallbackImage()]];
  };

  return <>{getDisplayImages()?.map(renderCard)}</>;
};

export default React.memo(Card);
